import React from "react";
import { styled } from "@mui/material/styles";
import { Select, FormControl, InputBase, MenuItem } from "@mui/material";

const MyFormControl = styled(FormControl)(({ theme }) => ({
  color: "#fff",
  "& label.Mui-focused": {
    color: "#fff",
    borderRadius: "12px",
  },
  "& .MuiInput-underline:after": {
    display: "none",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
      borderRadius: "12px",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
      borderRadius: "12px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
      borderRadius: "12px",
    },
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: "#fff",
    position: "relative",
    border: "none",
    fontSize: "16px",
    fontWeight: 500,
    padding: "10px 26px 10px 0px",
    [theme.breakpoints.down("md")]: {
      fontSize: "14px",
    },
    "&:focus": {
      border: "none",
      backgroundColor: "transparent",
    },
  },
  "& .MuiSvgIcon-root": {
    color: "#fff",
  },
}));

export default function Footer(props) {
  const { component } = props;
  const lang = component.getData("default.lang", "en");
  const languages = component.getData("default.languages", []);

  return (
    <>
      {languages.length !== 0 && (
        <MyFormControl variant="standard" sx={{ mr: 1, pl: 0 }}>
          <Select
            value={lang}
            onChange={(e) => component.selectLang(e.target.value)}
            input={<BootstrapInput />}
          >
            {languages.map((language) => {
              const { slug } = language;
              return (
                <MenuItem
                  key={`language-select-${slug}`}
                  value={slug}
                  sx={{ color: "#000" }}
                >
                  {component.ucfirst(slug)}
                </MenuItem>
              );
            })}
          </Select>
        </MyFormControl>
      )}
    </>
  );
}
